import { render, staticRenderFns } from "./ABTestInfo.vue?vue&type=template&id=208555c4&"
import script from "./ABTestInfo.vue?vue&type=script&lang=ts&"
export * from "./ABTestInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports